import { useAuth } from '@/contexts/auth-context';
import { PageHeader, PageSection } from '@/components/layouts/page-layout';
import { SettingsList } from '@/pages/dashboard/tenant/settings/settings-list';

export function SettingsPage() {
  const { user } = useAuth();
  const tenant = user?.tenant;

  if (!tenant?.slug) {
    return (
      <PageSection className="rounded-lg border border-dashed p-12 text-center text-muted-foreground">
        Loading tenant information...
      </PageSection>
    );
  }

  return (
    <>
      <PageHeader
        title="Settings"
        description="Manage tenant key-value settings"
      />
      <PageSection>
        <SettingsList tenantSlug={tenant.slug} />
      </PageSection>
    </>
  );
}
